export class Address extends String {
  constructor(value: string) {
    super(value)
  }
  shirinkAddress() {
    const frontaddress = this.substring(0, 5)
    const middleaddress = '..'
    const rearaddress = this.substring(this.length - 4)
    return frontaddress + middleaddress + rearaddress
  }
  equals(string: object | string) {
    return this.toString() === string.toString()
  }
}
